/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Tooltip, IconButton, Breadcrumbs, Typography } from '@material-ui/core';
import { ArrowBack, Edit, Clear } from '@material-ui/icons'
 
import RecordIcon from './RecordIcon'
import GroupIcon from '../Groups/GroupIcon';
import SingletonIcon from '../Singletons/SingletonIcon'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})
class RecordDetail extends Component {
    state = {}

    renderNavigation = () => {
        return (
            <Paper 
                variant = 'outlined'
                square
                style = {{
                    width : '100%',
                    height : '50px',
                    display : 'flex',
                    flexDirection : 'row'
                }}
            >
                <div style = {{
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    justifyContent : 'center'
                }}>
                    <Tooltip title = "Back">
                        <IconButton size = 'small' color = 'primary' onClick = {()=>{}}>
                            <ArrowBack fontSize = 'inherit'/>
                        </IconButton>
                    </Tooltip>
                </div>
                <div style = {{
                    display : 'flex',
                    flexDirection : 'row-reverse',
                    alignItems : 'center',
                    flexGrow : 1,
                    padding : '10px'
                }}>
                        {this.props.record.group_id !== -1 && <GroupIcon/>}
                        {this.props.record.group_id !== -1 && <Typography style = {{marginLeft : '3px', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>{this.props.record.group_name}</Typography>}
                        {this.props.record.group_id !== -1 && <Typography style = {{marginRight : '5px'}} variant = 'caption' color ='primary'>/</Typography>}
                        {this.props.record.group_id !== -1 ? <RecordIcon/> : <SingletonIcon/>}
                        <Typography style = {{marginLeft : '3px', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>{this.props.record.record_id}</Typography>
                </div>
            </Paper>
        )
    }

    renderDetails = () => {

    }

    renderFields = () => {

    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div 
                    style = {{
                        width : '100%', 
                        height : this.props.body_height + "px", 
                        backgroundColor : "#F5F5F5", 
                        overflow : "hidden",
                        display : 'flex',
                        flexDirection : 'column'
                    }}
                >
                    {this.renderNavigation()}
                    {this.renderDetails()}
                    {this.renderFields()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(RecordDetail);